import React from 'react';
import PropTypes from 'prop-types';
import { InsOutsPlayer } from './InsOutsPlayer';

/**
 * Renders a single team's player list grid or the dash fallback.
 *
 * @param {object} props - Component props.
 * @param {Array} [props.players] - Array of player items.
 * @param {string} props.side - 'home' or 'away' indicator.
 * @param {boolean} [props.isReversed] - Whether to reverse the player list display order.
 * @param {object} props.matchData - Full match and player context data.
 * @param {string} props.matchTitle - The title of the match.
 * @param {string} [props.teamId] - Club identifier.
 * @param {boolean} [props.isAFLW] - Whether the competition is AFLW.
 * @returns {React.JSX.Element} The team player grid.
 */
export const InsOutsTeamGrid = ({
    players,
    side,
    isReversed = false,
    matchData,
    matchTitle,
    teamId,
    isAFLW = false
}) => {
    if (!players?.length) {
        return (
            <span
                className={`team-lineups-ins-and-outs__empty team-lineups-ins-and-outs__empty--${side}`}
            >
                &ndash;
            </span>
        );
    }

    const playerList = isReversed ? [...players].reverse() : players;

    return (
        <div
            className={`team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--${side}`}
        >
            {playerList.map((item, index) => {
                if (!item) {
                    return null;
                }

                const player = item.player || item;

                return (
                    <InsOutsPlayer
                        key={player.playerId || index}
                        data={matchData}
                        player={player}
                        reason={item.reason}
                        match={matchData?.match || matchData}
                        matchTitle={matchTitle}
                        clubId={teamId}
                        isAFLW={isAFLW}
                    />
                );
            })}
        </div>
    );
};

InsOutsTeamGrid.propTypes = {
    players: PropTypes.array,
    side: PropTypes.oneOf(['home', 'away']).isRequired,
    isReversed: PropTypes.bool,
    matchData: PropTypes.object.isRequired,
    matchTitle: PropTypes.string.isRequired,
    teamId: PropTypes.string,
    isAFLW: PropTypes.bool
};
